import {
  Component,
  EventEmitter,
  Input,
  Output, forwardRef, Inject } from '@angular/core';

import { ApiService }     from '../api/api.service';
import { CompanyService } from '../companies/company.service';

@Component({
  selector   : 'wor-inspection-template-item',
  template: require('./inspection.template.item.component.html')
})
export class InspectionTemplateItemComponent {
  @Input() index    : number;
  @Input() item     : any;
  @Input() orderings: Array<number>;
  @Input() types    : Array<any>;

  @Output() onRemove  = new EventEmitter<any>();
  @Output() onReorder = new EventEmitter<any>();

  productSearchValue: any;

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService     : ApiService,
    @Inject(forwardRef(() => CompanyService))
    public  companyService : CompanyService
  ) {}

  ngOnInit () {
    this.productSearchValue = {
      id       : this.item.product_id,
      item_code: this.item.product_item_code
    };
  }

  formatProduct = ( product ) => {
    return typeof product === 'object'
      ? product.item_code
      : product;
  }

  searchProducts = ( typed : string ) => {
    return this.apiService.get('/products/product_labor_list', [ typed, 0, 5 ]);
  }

  chooseProduct ( product : any ) {
    this.item.product_item_code = product.item_code;
    this.item.product_id        = product.id;
  }

  showTypeOptions () : boolean {
    return this.item.inspection_type === 'GYR';
  }
}
